export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topbar-language.vue?vue&type=template&id=d62f8c10"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-language.vue?vue&type=template&id=d62f8c10
// module id = uXRR
// module chunks = 0